        (() => {
            const select = (q) => document.querySelector(q);
            const selectAll = (q) => document.querySelectorAll(q);

            const openBtns = selectAll('.js-open-video');
            const modal = select('#home-video-modal');
            const overlayCloseEls = selectAll('[data-close]');
            const video = select('#home-video-player');
            const mediaContainer = select('#hvm-media-container');
            const titleEl = select('#hvm-title');

            const getYouTubeEmbedUrl = (src) => {
                if (!src) return null;
                const m = src.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{11})/);
                if (m && m[1]) return `https://www.youtube.com/embed/${m[1]}?autoplay=1`;
                return null;
            };

            const openModal = (src, title) => {
                if (!src) return;
                // remove any existing iframe
                const existingIframe = mediaContainer.querySelector('iframe');
                if (existingIframe) existingIframe.remove();

                if (titleEl) {
                    const value = (title || '').trim();
                    titleEl.textContent = value;
                    titleEl.toggleAttribute('aria-hidden', value === '');
                }

                const yt = getYouTubeEmbedUrl(src);
                if (yt) {
                    // hide video element when showing iframe
                    video.style.display = 'none';
                    const iframe = document.createElement('iframe');
                    iframe.src = yt;
                    iframe.width = '100%';
                    iframe.height = '480';
                    iframe.setAttribute('frameborder', '0');
                    iframe.setAttribute('allow', 'autoplay; encrypted-media');
                    iframe.setAttribute('allowfullscreen', '');
                    iframe.style.maxHeight = '80vh';
                    mediaContainer.appendChild(iframe);
                } else {
                    // show html5 video
                    video.style.display = '';
                    const source = video.querySelector('source');
                    source.src = src;
                    video.load();
                    // autoplay when ready
                    const playPromise = video.play();
                    if (playPromise && typeof playPromise.then === 'function') {
                        playPromise.catch(() => { /* autoplay blocked */ });
                    }
                }

                // show
                modal.classList.add('open');
                modal.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
            };

            const closeModal = () => {
                // remove iframe if present
                const existingIframe = mediaContainer.querySelector('iframe');
                if (existingIframe) existingIframe.remove();

                // stop html5 video and clear source
                try { video.pause(); } catch (e) {
                    //console.warn('Error pausing video', e);
                }
                const source = video.querySelector('source');
                if (source) { source.src = ''; video.load(); }
                video.style.display = '';

                modal.classList.remove('open');
                modal.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';

                if (titleEl) {
                    titleEl.textContent = '';
                    titleEl.removeAttribute('aria-hidden');
                }
            };

            openBtns.forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    let src = btn.getAttribute('data-video');
                    const title = btn.getAttribute('data-video-title') || '';
                    if (!src || src.trim() === '') {
                        // nothing configured; try to look for link href
                        src = btn.getAttribute('href') || '';
                    }
                    openModal(src, title);
                });
            });

            overlayCloseEls.forEach((el) => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    closeModal();
                });
            });

            // close on escape
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && modal.classList.contains('open')) {
                    closeModal();
                }
            });
        })();
